import '../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';
import '../../node_modules/cssuseragent/cssua.js';
import '../../node_modules/@accessible360/accessible-slick/slick/slick.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import './pivot-base.js';

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.ScrollSmoother = ScrollSmoother;

gsap.registerPlugin(ScrollSmoother);
gsap.registerPlugin(ScrollTrigger);

const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
};

jQuery(document).ready(($) => {

  // Fixed element append
  const appendFixedElementsToBody = () => {
    const elements = document.querySelectorAll('[data-pd-append-to-body]');
    elements.forEach(el => {
      document.body.appendChild(el);
    })
  }

  // Move renewal buttons
  const appendFixedElementsToCover = () => {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const coverAppend = document.querySelector('.pd-append-cover');
    if (!coverAppend) {
      return;
    }
    if (viewportWidth > 992) {
      document.querySelector(".wp-block-cover-image").appendChild(coverAppend);
    } else {
      document.querySelector(".wp-block-renewal-modal").appendChild(coverAppend);
    }
  }

  // Change nav for mobile
  const changeNavOnMobile = () => {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const toolbarMobile = document.querySelector('.pd-toolbar-menu-wrap');
    const menuTrigger = document.querySelector(".pd-menu-trigger");
    const togglerMobile = document.querySelector('.pd-font-toggler');
    const langdropMobile = document.querySelector('.pd-lang-dropdown');
    if (viewportWidth > 992) {
      document.querySelector(".pd-nav-wrapper").prepend(toolbarMobile);
      document.querySelector(".pd-toolbar-menu-wrap .row").appendChild(togglerMobile);
      document.querySelector(".pd-toolbar-menu-wrap .row").appendChild(langdropMobile);
      matchHeights();
    } else {
      document.querySelector(".pd-main-menu-wrap .navbar-collapse").appendChild(toolbarMobile);
      menuTrigger.insertAdjacentElement("beforebegin", togglerMobile);
      menuTrigger.insertAdjacentElement("beforebegin", langdropMobile);
      matchHeights();
    }
  }

  // Hamburgers
  const $hamburger = $('.hamburger');
  const $body = $('body');
  $hamburger.on('click', function () {
    $hamburger.toggleClass('is-active');
    $('.pd-toggle-label').html() == 'Close' ? $('.pd-toggle-label').html('Menu') : $('.pd-toggle-label').html('Close'); // Toggle Label
    $body.toggleClass('pd-menu-open'); // Toggle nav background
  });

  // Query string helper function
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  // Open modals with query strings
  var openModal = getParameterByName('show');
  if (openModal) {
    $('#pd-' + openModal).modal('show');
  }

  // Query strings for anchor links
  // const anchor = getParameterByName('anchor');
  // if (anchor) {
  //   const element = $('#' + anchor);
  //   if (element.length) {
  //     $('html, body').animate({ scrollTop: element.offset().top }, 'slow');
  //   }
  // }

  // Slick
  $('.pd-slider').slick({
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    adaptiveHeight: true,
  });

  // Get the slide index from the query string
  var slideIndex = parseInt(getParameterByName('renew-step')) - 1;

  // Check if the slide index is valid (not NaN)
  if (!isNaN(slideIndex)) {
    $('.pd-slider').slick('slickGoTo', slideIndex);
  }

  // Find the height of the tallest slide among the first four slides on desktop
  if ($(window).width() > 992) {
    var tallestHeight = 0;
    $('.pd-slider .slick-slide').slice(0, 4).each(function () {
      var slideHeight = $(this).height();
      if (slideHeight > tallestHeight) {
        tallestHeight = slideHeight;
      }
    });

    // Set the height of the first four slides to match the tallest slide
    $('.pd-slider .slick-slide').slice(0, 4).css('height', tallestHeight);
  }

  // Trigger Manage modal with class
  $('.pd-manage-open').on('click', function(event) {
    event.preventDefault();
    $('#pd-manage').modal('show');
  });

  // Trigger Need modal with class
  $('.pd-need-open').on('click', function(event) {
    event.preventDefault();
    $('#pd-need').modal('show');
  });

  // Trigger Envelope modal with class
  $('.pd-envelope-open').on('click', function(event) {
    event.preventDefault();
    $('#pd-envelope').modal('show');
  });

  // Add div for skip links to every page
  var mainContent = $('<div id="pd-skipto"></div>');
  $('#pd-content').children().first().after(mainContent);

  // Add row to toolbar nav
  $('.pd-toolbar-menu-wrap > .container').children().wrapAll('<div class="row ml-lg-auto justify-content-center"></div>');

  // Use matchHeight for headers
  function matchHeights() {
    // Move body down when nav is fixed
    $("#pd-main").css({ "padding-top": $(".pd-nav-wrapper").outerHeight() });
    // Admin body adjust
    $("body.admin-bar #pd-main").css({ "padding-top": $(".pd-nav-wrapper").outerHeight() + $("#wpadminbar").outerHeight() });
    // Admin nav adjust
    $("body.admin-bar .pd-nav-wrapper").css({ "top": $("#wpadminbar").outerHeight() });
  }

  // Font sizing toggler
  function fontToggler() {
    var changeElement = document.querySelector('html');
    $(changeElement).addClass('font-size--default');
    $('.pd-font-toggler').click(function () {
      if ($(changeElement).hasClass('font-size--default')) {
        $(changeElement).removeClass('font-size--default');
        $(changeElement).addClass('font-size--large');
      }
      else if ($(changeElement).hasClass('font-size--large')) {
        $(changeElement).removeClass('font-size--large');
        $(changeElement).addClass('font-size--small');
      }
      else if ($(changeElement).hasClass('font-size--small')) {
        $(changeElement).removeClass('font-size--small');
        $(changeElement).addClass('font-size--default');
      }
    });
  }

  // Add event listener to the buttons that toggle the modals
  function doubleModal() {
    // Add z-index fix to double modal instances
    $('a[data-toggle="modal"]').on('click', function () {
      var currentModal = $('.modal.show');
      var newModal = $($(this).data('target'));
      if (currentModal.length > 0) {
        var topZIndex = Math.max.apply(null, currentModal.map(function () {
          return parseInt($(this).css('z-index'));
        }).get());
        newModal.css('z-index', topZIndex + 10); // Increase z-index to place it on top
        newModal.one('show.bs.modal', function () {
          smoother.paused(true); // Pause the ScrollSmoother
          var modalBackdrop = $('<div class="modal-backdrop fade show"></div>');
          modalBackdrop.css('z-index', topZIndex + 5); // Adjust z-index for the backdrop
          $('body').append(modalBackdrop);
        });
        newModal.one('hidden.bs.modal', function () {
          smoother.paused(true); // Keep the ScrollSmoother paused for other instances
          newModal.css('z-index', ''); // Reset z-index when the modal is closed
          $('.modal-backdrop').last().remove(); // Remove the last appended modal-backdrop
          // Re-enable scrolling for the original modal
          if (currentModal.length) {
            $('body').addClass('modal-open');
          }
        });
      }
      newModal.modal('show');
    });
  }

  function getTranslation() {
    var translations = {
      en: 'Start over',
      es: 'Start over',
      pl: 'Zacznij od początku'
    };
  
    return translations[wpmlSettings.currentLanguage] || translations['en']; // default to English
  }

  function formCustom() {
    var startOverText = getTranslation(); // Get the translated text
  
    // Add start over button to each page
    $('.gform_page_footer').prepend('<button type="button" id="pd-restart" class="gform_start_button btn btn-link">' + startOverText + '</button>');
    // Add start over button to confirmation pages
    $('.gform_confirmation_message').append('<div class="gform_page_footer top_label"><button type="button" id="pd-restart" class="gform_start_button btn btn-link">' + startOverText + '</button></div>');
    // Add wrapper to primary form legends
    $('.pd-form-primary .gfield_label').each(function() {
      $(this).wrap('<div class="pd-circle-wrapper"></div>');
    });
  }  
  

  // Gravity forms class updates
  $('.gform_page').eq(0).addClass('pd-current'); // Show the current page on form load
  if ($('.gform_page').hasClass('pd-current')) {
    // $('form#gform_1 input[type="submit"]').hide();
    $('form#gform_1 input[type="radio"]').on('click', function () {
      $('form#gform_1').trigger("submit");
    });
  }

  $(document).on('gform_page_loaded', function (event, form_id, current_page) {
    // Add "current" class to current page on page change
    $('.gform_page').removeClass('pd-current');
    $('.gform_page').eq(current_page - 1).addClass('pd-current');

    // Add custom class to parent element on page change
    var currentPageClass = $('.gform_page').eq(current_page - 1).attr('class').split(' ').filter(function (c) {
      return c.indexOf('pd-form-primary') === 0 || c.indexOf('pd-form-secondary') === 0;
    });
    if (currentPageClass.length) {
      $('.pd-renewal-modal > .modal-fullscreen').removeClass('pd-form-primary pd-form-secondary').addClass(currentPageClass[0]);
    } else {
      $('.pd-renewal-modal > .modal-fullscreen').removeClass('pd-form-primary pd-form-secondary');
    }

    // Clear pages as they load
    $(".pd-current .gfield_checkbox input[type='checkbox']").prop('checked', false);
    $(".pd-current .gfield_radio input[type='radio']").prop('checked', false);

    // Auto-submit if on last page
    if ($('.gform_page').hasClass('pd-current')) {
      // $('form#gform_1 input[type="submit"]').hide();
      $('form#gform_1 input[type="radio"]').on('click', function () {
        $('form#gform_1').trigger("submit");
      });
    }

    formCustom(); // Add start over button
  });

  // Do things when the confirmation page is loaded
  $(document).on('gform_confirmation_loaded', function (event, form_id) {
    $('.pd-renewal-modal > .modal-fullscreen').removeClass('pd-form-primary pd-form-secondary');
    $('.pd-renewal-modal > .modal-fullscreen').addClass('pd-form-confirmation');

    doubleModal(); // Run modal function again here
    formCustom(); // Add start over button
  });

  // Reload the current page and scroll to an anchor link
  function reloadPageAndScrollToAnchor(anchor) {
    var url = window.location.protocol + '//' + window.location.host + window.location.pathname;
    console.log(url)
    console.log(url + '#' + anchor)
    if(window.location.href == url + '#' + anchor || window.location.href == url){
      window.location.href = url + '#' + anchor;
      window.location.reload()
    } else {
      window.location.href = url + '#' + anchor;
    }

  
    function scrollToAnchor() {
      var target = document.querySelector('#' + anchor);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollToAnchor);
    } else {
      scrollToAnchor();
    }
  }



  // Reload form from confirmation page
  $(document).on('click', '#pd-restart', function (event) {
    //event.preventDefault();
    //reloadPageAndScrollToAnchor('interactive-tool');
    if(!window.location.href.includes('?')){
      window.location.replace(location.pathname + "#interactive-tool");
      window.location.reload()
    } else {
      window.location.replace(location.pathname + "#interactive-tool");
    }
    // Clear form on reset
    $(".gfield_checkbox input[type='checkbox']").prop('checked', false);
    $(".gfield_radio input[type='radio']").prop('checked', false);
  });



  

  // Recreate Headroom with ScrollTrigger
  var siteHeader = $('.pd-nav-wrapper')[0];
  var header_progress = 0;
  var header_direction = 1;
  var toolbarHeight = $(".pd-toolbar-menu-wrap").outerHeight(); // Meridian custom
  ScrollTrigger.create({
    trigger: "#pd-main",
    start: "+=100",
    end: 'bottom bottom',
    onUpdate: function (self) {
      header_progress = self.progress.toFixed(2);
      header_direction = self.direction;
      if (header_progress == 0.00) {
        $(siteHeader).addClass('pd-top').removeClass('pd-not-top').css("transform", "translateY(0px)"); // Meridian custom
        $('body').removeClass('pd-is-scrolled');
      } else {
        $(siteHeader).removeClass('pd-top').addClass('pd-not-top').css("transform", "translateY(-" + toolbarHeight + "px)"); // Meridian custom
        $('body').addClass('pd-is-scrolled');
      }
      if (header_direction == 1) {
        $(siteHeader).addClass('pd-unpinned').css("transform", "translateY(0px)"); // Meridian custom
      } else {
        $(siteHeader).removeClass('pd-unpinned').css("transform", "translateY(-" + toolbarHeight + "px)"); // Meridian custom
      }
      if (header_direction == -1) {
        $(siteHeader).addClass('pd-pinned').css("transform", "translateY(0px)"); // Meridian custom
      } else {
        $(siteHeader).removeClass('pd-pinned').css("transform", "translateY(-" + toolbarHeight + "px)"); // Meridian custom
      }
    }
  });

  // Need a dummy scrolltrigger instance before scrollsmooth gets initialized
  let dummytl = gsap.timeline({
    scrollTrigger: {
      trigger: 'body',
    }
  });

  // Check for touch devices
  function isTouchDevice() {
    return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
  }

  if (isTouchDevice()) {
    // Is Mobile
    // ScrollTrigger.normalizeScroll(true)
    window.pd_smoother = false
  } else {
    // ScrollSmoother
    var smoother = ScrollSmoother.create({
      wrapper: "#pd-inner",
      content: "#pd-main",
      smooth: 1,
      effects: true,
      ignoreMobileResize: true,
      normalizeScroll: true,
      preventDefault: false,
    });
    
    window.pd_smoother = smoother

    // Bizarre bug, but will not scroll without timeout
    window.setTimeout(() => {
      smoother.scrollTo(window.location.hash, true, "top 100px")
    },50)




    // pause smooth scroll when modals are open to allow internal scrolling
    $('.modal').on('show.bs.modal', function () {
      smoother.paused(true);
    });
    $('.modal').on('hide.bs.modal', function () {
      smoother.paused(false);
    });
    // Include smoother pausing in the parameter method
    if (openModal) {
      smoother.paused(true);
    }

    // Get the outer height of the navigation menu
    function getNavOuterHeight() {
      const nav = document.querySelector('nav.pd-main-menu-wrap');
      if (nav) {
        const rect = nav.getBoundingClientRect();
        const style = getComputedStyle(nav);
        const marginTop = parseFloat(style.marginTop);
        const marginBottom = parseFloat(style.marginBottom);
        return rect.height + marginTop + marginBottom;
      }
      return 0;
    }

    // Click event listener for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        if (this.getAttribute('href') !== "#") {
          const target = document.querySelector(this.getAttribute('href'));
          if (target) {
            const navOuterHeight = getNavOuterHeight();
            const yOffset = target.getBoundingClientRect().top + window.pageYOffset - navOuterHeight;
            smoother.scrollTo(yOffset, { duration: 1, ease: 'power2.inOut' });
          }
        }
      });
    });


    // Hero Parallax
    var parallaxBg = document.querySelectorAll(".pd-parallax-bg img");
    if (parallaxBg.length > 0) {
      gsap.to(parallaxBg, {
        yPercent: 20,
        ease: "none",
        scrollTrigger: {
          trigger: ".pd-home-hero,.meridian-hero-secondary",
          scrub: true,
        },
      });
    }

    // Home Hero parallax
    var homeHero = document.querySelectorAll(".pd-parallax-headline img");
    if (homeHero.length > 0) {
      gsap.fromTo(homeHero, { y: 0 }, { y: -30, scrollTrigger: { trigger: ".pd-home-hero", start: "top 141", end: "bottom top", scrub: true }, });
    }

    // CTA Parallax
    var parallaxCta = document.querySelectorAll(".pd-parallax-bg-cta img");
    if (parallaxCta.length > 0) {
      gsap.to(parallaxCta, {
        yPercent: 20,
        ease: "none",
        scrollTrigger: {
          trigger: ".meridian-cta-contact",
          scrub: true,
        },
      });
    }
  }

  // Move Scroll Indicator
  function heroAnimation() {
    let heroGraphic = document.querySelector('.pd-parallax-headline img');
    if (heroGraphic) {
      let graphicWidth = heroGraphic.offsetWidth;
      document.getElementById("hh-scroll").style.width = graphicWidth + "px";
      $('#hh-scroll').fadeIn(1000); // Fade in the scroll indicator over 1 second
    }
  }

  // Video modal 
  const videoModal = $('.pd-video-modal');

  // Play video on modal open
  if (videoModal.length) {
      const video = videoModal.find('video')[0];
      videoModal.on('shown.bs.modal', function () {
        video.play();
        video.setAttribute('controls', 'controls');
      });
      // Stop video on modal close
      videoModal.on('hide.bs.modal', function () {
        video.pause();
        video.removeAttribute('controls');
      });
  }

  matchHeights();
  appendFixedElementsToBody();
  appendFixedElementsToCover();
  changeNavOnMobile();
  fontToggler();
  doubleModal();
  formCustom();



  // Event listeners and triggers
  $(window).on("load", () => {
    heroAnimation();
  });

  // Resize with debounce
  $(window).on('resize', debounce(() => {
    if (!isTouchDevice()) {
      ScrollTrigger.refresh();
    }
    matchHeights();
    heroAnimation();
    appendFixedElementsToCover();
    changeNavOnMobile();
  }, 250));
});

